import React from 'react';
import ReactDOM from 'react-dom';
import {observer} from 'mobx-react';
import {onReactionError} from 'mobx';

import {captureException} from 'capture_sentry_exception.js';
import events from 'events.js';

import {MOBILE_MAX_SCREEN_SIZE} from 'base/search.js';
import {snakeToCamelObjectKeys} from 'utils/case_converter.js';
import autobind from 'common/decorators/autobind.js';

import FocusManager from 'core/components/FocusManager.js';
import {HospitalDirectoryStoreContext} from 'core/stores/RootStore.js';
import HospitalDirectoryHeader from 'directory/components/HospitalDirectoryHeader.js';
import HospitalDirectoryHFRFilter from 'directory/components/HospitalDirectoryHFRFilter.js';
import HospitalHealthFundInfo from 'directory/components/HospitalHealthFundInfo.js';
import HospitalSearchResults from 'directory/components/HospitalSearchResults.js';
import HospitalHealthFundDisclaimer from 'directory/components/HospitalHealthFundDisclaimer.js';

export default
@observer
class HospitalDirectoryApp extends React.Component {
    static contextType = HospitalDirectoryStoreContext;

    constructor(props) {
        super(props);
        onReactionError(captureException);
        this.mobileMediaQuery = window.matchMedia(
            `screen and (max-width: ${MOBILE_MAX_SCREEN_SIZE})`,
        );
    }

    componentDidMount() {
        const {locality, userType} = this.props;
        this.onWindowResize();
        events.listen(window, ['resize', 'orientationchange'], () => {
            this.onWindowResize();
        });
        this.context.updateStore({
            hasLoaded: false,
            locality,
            userType,
        });
    }
    componentWillUnmount() {
        events.unlisten(window, ['resize', 'orientationchange'], () => {
            this.onWindowResize();
        });
    }

    @autobind
    onWindowResize(event) {
        this.context.updateStore({
            isMobile: window.matchMedia(
                `(max-width: ${MOBILE_MAX_SCREEN_SIZE})`,
            ).matches,
        });
    }

    render() {
        return (
            <>
                <FocusManager />
                <HospitalDirectoryHeader />
                <section className="result-list">
                    <HospitalDirectoryHFRFilter />
                    <HospitalHealthFundInfo />
                    <HospitalHealthFundDisclaimer />
                    <HospitalSearchResults />
                </section>
            </>
        );
    }
}

(async function () {
    await events.ready();

    const directorySection = document.getElementById('hospitalDirectory');
    const props = snakeToCamelObjectKeys(
        JSON.parse(directorySection.dataset.directory),
    );
    props.userType = document.body.dataset.userType;
    ReactDOM.render(<HospitalDirectoryApp {...props} />, directorySection);
})();
